import { useHistory } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import { useAuth } from './Auth'
import { ADMIN_URL, MANAGER_URL } from '../constants'
import { inviteDestination, rolesFromUser } from './inviteDestination'

// Where a user goes after signing in here. Sign-in and sign-up both follow this one rule.
export const useLandAfterSignIn = () => {
    const history = useHistory()
    const auth = useAuth()
    const [cookies] = useCookies(['inviteRole'])

    // Each app keeps its own session, so the user signs in again there.
    const leaveForApp = (url) => auth.signout().then(() => window.location.replace(url))

    return (user) => {
        // An invite that granted an admin or manager role lands the user in that role's
        // app, even when they are also a consumer here.
        const destination = inviteDestination(cookies?.inviteRole, rolesFromUser(user))
        const isAdminOrManager = auth.isUserAdminOrManager(user)
        if (destination) {
            leaveForApp(destination)
        } else if (isAdminOrManager.isUserAdminOrManager && !auth.hasConsumerAppPersona(user)) {
            // Without an invite, an admin or manager who also holds a persona this app
            // serves (a consumer, granted on their first sign-in here) stays; only one who
            // holds none is sent to their own app.
            leaveForApp(isAdminOrManager.isUserAdmin ? ADMIN_URL : MANAGER_URL)
        } else if (auth.isUserInstaller(user)) {
            history.push('/installer-dashboard')
        } else {
            history.push('/dashboard')
        }
    }
}
